import * as types from '../constants/ActionTypes';

export const initialState = {
  isModalOpen: false,
  isRiskCheckError: false,
  loaded: false,
  isLoading: false,
  riskInfo: undefined,
  fromChannel: undefined,
  redirectToChannel: false,
  topic: undefined,
  anw: {
    isLoading: false,
    anwUrl: undefined,
    anwError: false,
    isRedirectedToAnw: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOAD_STEP_UP_CONTAINER:
      return { ...state, isModalOpen: true };

    case types.CLOSE_STEP_UP_CONTAINER:
      return {
        ...state,
        isModalOpen: false,
        redirectToChannel: action.payload,
      };

    case types.RESET_STEP_UP:
      return initialState;

    case types.REQUEST_RISK_CHECK_INITIATED:
      return {
        ...state,
        loaded: false,
        isModalOpen: false,
        isLoading: true,
        isRiskCheckError: false,
        riskInfo: undefined,
        fromChannel: action.fromChannel,
        topic: action.selectedTopic,
      };

    case types.RECEIVE_RISK_CHECK:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        riskInfo: action.payload,
      };

    case types.RECEIVE_RISK_ERROR:
      return {
        ...state,
        loaded: true,
        isLoading: false,
        isRiskCheckError: true,
        riskInfo: undefined,
        redirectToChannel: true,
      };

    case types.RECEIVED_RISK_ALLOW:
      return { ...state, redirectToChannel: true };

    case types.REQUEST_ANW_CHECK_INITIATED:
      return {
        ...state,
        isModalOpen: false,
        anw: { ...state.anw, isLoading: true },
      };

    case types.RECEIVE_ANW_SUCCESS:
      return {
        ...state,
        anw: {
          ...state.anw,
          isLoading: false,
          anwUrl: action.payload,
          isRedirectedToAnw: true,
        },
      };

    case types.RECEIVE_ANW_ERROR:
      return {
        ...state,
        redirectToChannel: true,
        anw: {
          ...state.anw,
          isLoading: false,
          anwError: true,
          anwUrl: undefined,
        },
      };

    case types.BACK_TO_CONTACT_HOME:
      return initialState;

    default:
      return state;
  }
}
